/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import { HeadingDescSmall } from '../../../Components/Headings';
import SubscriptionPakeges from '../../../Components/subscriptionPakeges/SubscriptionPakeges';
import check from '../../../assets/images/svg/check.svg';
import star from '../../../assets/images/svg/big-star.svg';
import './subscriptionBoxes.css';

const subscriptionData = [
  {
    image: '',
    name: 'Basic',
    price: 'Rs. 500',
    discount: '',
    time: 'Monthly',
    status: true,
    expiryDate: '*Expires on April 15, 2021',
    detail:
      'Get multiple HealthCheck scan in a single day of yourself and your loved ones with instant doctor consultations!',
    btnText: 'buy now',
    subsPointsHeading: 'What’s Included',
    subsPoints: [
      '3 editable boards',
      'Premade templates',
      'Core integrations',
      'Basic attention management'
    ]
  },
  {
    image: star,
    name: 'Normal',
    price: 'Rs. 2500',
    discount: 'Rs. 2700',
    time: '6 Months',
    status: false,
    expiryDate: '*Expires on April 15, 2021',
    detail:
      'Get multiple HealthCheck scan in a single day of yourself and your loved ones with instant doctor consultations!',
    btnText: 'buy now',
    subsPointsHeading: 'All Basic Features, plus',
    subsPoints: [
      'Unlimited editable boards ',
      'Unlimited visitors',
      'Custom templates ',
      'Projects Private boards',
      'Private boards'
    ]
  },
  {
    image: '',
    name: 'Pro',
    price: 'Rs. 5000',
    discount: '',
    time: 'Yearly',
    status: false,
    expiryDate: '*Expires on April 15, 2021',
    detail:
      'Get multiple HealthCheck scan in a single day of yourself and your loved ones with instant doctor consultations!',
    btnText: 'buy now',
    subsPointsHeading: 'All Normal Features, plus',
    subsPoints: [
      'Unlimited guests ',
      'Miro Smart Diagramming',
      'Miro Smart Meetings',
      'Single Sign On (SSO): access through OKTA, OneLogin,',
      'Auth0 and more'
    ]
  }
];

function SubscriptionBoxes() {
  return (
    <section className="subscription subscriptionBoxes">
      <Container>
        <Row>
          <Col md={12}>
            <div className="subsContainer">
              {subscriptionData.map((data) => {
                const {
                  image,
                  name,
                  price,
                  discount,
                  time,
                  status,
                  expiryDate,
                  detail,
                  btnText,
                  subsPointsHeading,
                  subsPoints
                } = data;
                return (
                  <SubscriptionPakeges
                    status={status}
                    image={image}
                    subsName={name}
                    subsPrice={price}
                    discountedPrice={discount}
                    timePeriod={time}
                    detail={detail}
                    expiryDate={expiryDate}
                    btnText={btnText}
                    subsPointsHeading={subsPointsHeading}
                    subsPoints={subsPoints.map((point) => (
                      <li>
                        <img src={check} alt="check" />
                        <HeadingDescSmall text={point} />
                      </li>
                    ))}
                  />
                );
              })}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SubscriptionBoxes;
